import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const Footer = () => {
  // Animation Variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const childVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, ease: "easeOut" },
    },
  };

  return (
    <footer className="bg-black text-gray-400 py-10">
      <motion.div
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10"
      >
        {/* Logo & About Section */}
        <motion.div variants={childVariants}>
          <Link to="/" className="flex no-underline items-center mb-4">
            <img
              src="../logo.jpg" // Replace with your logo path
              alt="Logo"
              className="h-10 w-10 mr-2"
            />
            <span className="text-white  text-xl font-bold">
              Zenetix IT Solutions
            </span>
          </Link>
          <p>
            Providing innovative IT solutions for modern businesses. Let us
            help you grow and succeed in the digital era.
          </p>
        </motion.div>

        {/* Useful Links */}
        <motion.div variants={childVariants}>
          <h4 className="text-white text-lg font-bold mb-4">Useful Links</h4>
          <ul className="space-y-2">
            <li>
              <Link
                to="/"
                className="text-gray-500 hover:text-white no-underline transition duration-300"
              >
                Home
              </Link>
            </li>
            <li>
              <Link
                to="/about"
                className="text-gray-500 hover:text-white no-underline transition duration-300"
              >
                About Us
              </Link>
            </li>
            <li>
              <Link
                to="/services"
                className="text-gray-500 hover:text-white no-underline transition duration-300"
              >
                Services
              </Link>
            </li>
            <li>
              <Link
                to="/contact"
                className="text-gray-500 hover:text-white no-underline transition duration-300"
              >
                Contact
              </Link>
            </li>
            <li>
              <Link
                to="/careers"
                className="text-gray-500 hover:text-white no-underline transition duration-300"
              >
                Careers
              </Link>
            </li>
          </ul>
        </motion.div>

        {/* Contact Details */}
        <motion.div variants={childVariants}>
          <h4 className="text-white text-lg font-bold mb-4">Contact Details</h4>
          <p>
          <strong>Address:</strong> Plot No 12, 4th floor, Software Units Layout, Madhapur, Hyderabad, Telangana - 500081
          </p>
          <p>
            <strong>Email:</strong>{" "}
            <a href="mailto:hr@zenetixitsolutions.com" className="text-gray-500 hover:text-white no-underline">
              hr@zenetixitsolutions.com
            </a>
          </p>
          <p>
            <strong>Phone:</strong>{" "}
            <a href="tel:7799799100" className="text-gray-500 hover:text-white no-underline">
              7799799100
            </a>
          </p>
        </motion.div>

        {/* Social Media */}
        <motion.div variants={childVariants}>
          <h4 className="text-white text-lg font-bold mb-4">Follow Us</h4>
          <div className="flex space-x-4">
            {/* <a
              href="#"
              className="bg-gray-700 hover:bg-gray-600 text-white p-2 rounded-full transition duration-300"
            >
              <i className="fab fa-facebook-f"></i>
            </a>
            <a
              href="#"
              className="bg-gray-700 hover:bg-gray-600 text-white p-2 rounded-full transition duration-300"
            >
              <i className="fab fa-twitter"></i>
            </a>
            <a
              href="#"
              className="bg-gray-700 hover:bg-gray-600 text-white p-2 rounded-full transition duration-300"
            >
              <i className="fab fa-linkedin-in"></i> */}
            {/* </a> */}
            <a
              href="https://www.instagram.com/zenetixit/"
              className="bg-gray-700 hover:bg-gray-600 text-white p-2 rounded-full transition duration-300"
            >
              <i className="fab fa-instagram"></i>
            </a>
          </div>
        </motion.div>
      </motion.div>

      {/* Footer Bottom */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.2, duration: 0.8 }}
        className="mt-10 border-t border-gray-700 pt-6 text-center"
      >
        <p>
          &copy; {new Date().getFullYear()} Zenetix IT Solutions. All Rights
          Reserved.
        </p>
      </motion.div>
    </footer>
  );
};

export default Footer;
